import { Component, Input } from '@angular/core';
import { DateFormat } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { LsqGroupedDataTableComponent, TotalsRowKeyPair } from '@lsq-frontend/common-ui';
import {
    GetPurchasesRequest,
    GetPurchasesResponse,
    Purchase
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { LsqApiServiceListSource } from '@lsq-frontend/angular-shared/api-service';

@Component({
    selector: 'purchases-grouped-table',
    templateUrl: './purchases.grouped-table.component.html',
    styleUrls: ['./purchases.grouped-table.component.scss']
})
export class PurchasesGroupedTableComponent extends LsqGroupedDataTableComponent {
    @Input() public dataSource: LsqApiServiceListSource<
        GetPurchasesResponse,
        GetPurchasesRequest,
        Purchase[]
    >;

    // Constants.
    public dateFormat = DateFormat;
    public icons = Icons;

    public isRowExpandable(row: Purchase): boolean {
        return row.status !== 'Submitted';
    }

    public setTotalsRowKeyPairs(): TotalsRowKeyPair[] {
        return undefined;
    }
}
